import Vue from "vue";
import { extend, localize } from "vee-validate";
import { required, email, regex, oneOf, alpha } from "vee-validate/dist/rules";
import fr from "vee-validate/dist/locale/fr.json";

// import { configure } from 'vee-validate';

// configure({
//   classes: {
//     valid: 'is-valid',
//     invalid: 'is-invalid',
//   }
// });

// Install required rule.
extend("required", required);
extend("email", { ...email, message: "Entrez une adresse email valide." });
extend("regex", { ...regex });
extend("oneOf", { ...oneOf });
extend("alpha", { ...alpha });
extend("minimalLengthAndIsObject", value => {
    return value.length > 0 || value.constructor.name === "Object";
});


// Install English and Arabic localizations.
localize({
    fr: {
        messages: fr.messages,
        names: {
            name: "nom",
            email: "courriel",
            phone: "téléphone",
            address: "adresse",
            message: "message",
        },
        fields: {
            name: {
                regex: "Le nom ne peut contenir que des alphabets, des espaces et des tirets."
            },
            phone: {
                regex: "Le numéro de téléphone n'est pas valide."
            },
            address: {
                minimalLengthAndIsObject: "L'adresse n'est pas valide."
            },
            message: {
                required: "Décrivez brièvement votre demande."
            }
        }
    }
});

let LOCALE = "fr";

// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
    get() {
        return LOCALE;
    },
    set(val) {
        LOCALE = val;
        localize(val);
    }
});
